import { createComponent } from '@carvana/vdp-components';
import BottomFrameRule from './BottomFrameRule';
import GetItBy from './GetItBy';
import Shipping from './Shipping';
import { useDeliveryOrPickupChipGetItBy } from '../hooks';

const SectionWrapper = createComponent('section', {
  className:
    'box-border grid grid-flow-row grid-rows-[min-content,max-content] relative'
});

const ShippingAndGetItBy = () => {
  const { getItBy } = useDeliveryOrPickupChipGetItBy();

  return (
    <SectionWrapper>
      <BottomFrameRule getItBy={getItBy} />
      <div className="flex items-center t-body-xs">
        <Shipping getItBy={getItBy} />
        <GetItBy getItBy={getItBy} />
      </div>
    </SectionWrapper>
  );
};

export default ShippingAndGetItBy;
